export const feedbackFormTypes = {
  ORDER_FEEDBACK: 'ORDER_FEEDBACK',
}

export const feedbackFormItemTypes = {
  TEXTAREA: 'TEXTAREA',
  FILE: 'FILE',
  MARKDOWN: 'MARKDOWN',
}
